/**
 * Created by renlaydel on 04/12/2017.
 */
export const STORE = "store";
